import { useEffect } from 'react';

import StNavbar from "../components/StNavbar";
import StFooter from "../components/StFooter";

import '../App2.css';
import '../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { SetSeo } from '../lib/common_funcs';

function StContactUs() {

    const contactPageSeo = {
        "title": "Contact TurboSteed Support & Sales",
        "description": "Need help with hosting, billing, or technical support? Contact the TurboSteed team directly via phone, chat, or submit a support ticket.",
        "canonicalUrl": "https://turbosteed.com/contactus",
        "keywords": "TurboSteed contact, hosting support, technical help, sales inquiry",
        "ogType": "website",
        "ogTitle": "Contact the TurboSteed Team",
        "ogDescription": "Our expert support team is available 24/7 to help you with any hosting, billing, or technical question.",
        "ogImage": "https://turbosteed.com/images/social/share-contact.jpg",
        "twitterCard": "summary",
        "robots": "noindex, follow", // Prevents this page from cluttering search results
		// All other values will be default
	}
	
	const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "ContactPage"
    }

    const allParams = {
		"seo": contactPageSeo,
		"schema": schemaMarkup
	}

    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            easing: 'ease-out-cubic',
            offset: 50
        });
    }, []);

    return (
        <div className="ts-redesign">

            {/* Call the Seo component at the top of the page component */}
            <SetSeo {...allParams} />

            <StNavbar />

            <header className="ts-page-hero">
                <div className="ts-hero-bg">
                    <div className="ts-gradient-orb ts-orb-1"></div>
                    <div className="ts-gradient-orb ts-orb-2"></div>
                </div>
                <div className="container">
                    <h1 className="ts-page-title" data-aos="fade-up">Contact Us</h1>
                    <p className="ts-page-subtitle" data-aos="fade-up" data-aos-delay="100">We'd love to hear from you</p>
                </div>
            </header>

            <main className="main-content">
                <section className="ts-section ts-section-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10">
                                <div className="row g-4">
                                    <div className="col-md-6" data-aos="fade-up">
                                        <div className="ts-bento-card h-100 text-center">
                                            <div className="ts-bento-card-icon" style={{margin: '0 auto 1.5rem'}}>
                                                <i className="fa fa-envelope"></i>
                                            </div>
                                            <h3>Email Support</h3>
                                            <p>Have a question or need help? Send us an email and we'll get back to you within 24 hours.</p>
                                            <a href="mailto:support@turbosteed.com" className="ts-btn ts-btn-primary">
                                                support@turbosteed.com
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                                        <div className="ts-bento-card h-100 text-center">
                                            <div className="ts-bento-card-icon" style={{margin: '0 auto 1.5rem'}}>
                                                <i className="fa fa-book"></i>
                                            </div>
                                            <h3>Documentation</h3>
                                            <p>Find guides, tutorials, and answers to common questions in our documentation.</p>
                                            <a href="/docs" className="ts-btn ts-btn-primary">
                                                Visit Docs
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <StFooter />

        </div>
    );
}

export default StContactUs;
